import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { useFormContainerContext } from '../../../Services/FormContainerContext';
import DiagnosisSelect from './DiagnosisSelect';
import TopFieldContent from '../../Form/components/TopFieldContent';
import RichText from '../../../Modules/Base/Components/Inputs/RichText/RichText';
import ErrorMessage from '../../Form/components/ErrorMessage';

interface DiagnosisSelectFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	portal?: boolean;
}

const DiagnosisSelectField: React.FC<DiagnosisSelectFieldProps> = ({
	name,
	label,
	isRequired,
	className,
	portal,
}) => {
	const { name: formContainerName } = useFormContainerContext();
	const finalName = formContainerName ? `${formContainerName}.${name}` : name;

	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: finalName || '',
	});
	return (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<DiagnosisSelect
				value={field.value}
				onChange={field.onChange}
				portal={portal}
			/>
			{error?.message && <ErrorMessage tx={error.message} />}
		</div>
	);
};

export default DiagnosisSelectField;
